import _jsx from "@babel/runtime/helpers/jsx";
import React from 'react';
import clsx from 'clsx';
import BootstrapAlert from '../bootstrap/Alert.js';
import Glyphicon from '../Glyphicon/index.js';
import CloseButton from '../CloseButton/index.js';
function Alert(_ref) {
  let {
    bsStyle,
    withIcon = true,
    children,
    onDismiss,
    className,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(BootstrapAlert, Object.assign({}, rest, {
    bsStyle: bsStyle,
    className: clsx(className, {
      'alert-noicon': !withIcon
    }, {
      'alert-dismissible': onDismiss
    })
  }), withIcon && /*#__PURE__*/_jsx(Glyphicon, {
    glyph: bsStyle,
    "aria-hidden": "true"
  }), children, onDismiss && /*#__PURE__*/_jsx(CloseButton, {
    onClick: onDismiss
  }));
}
export default Alert;